import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icon-new.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-67a53aca")

_pushScopeId("data-v-67a53aca")
const _hoisted_1 = {
  class: "tag",
  id: "tag"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", null, "配置标签", -1)
const _hoisted_3 = { class: "main" }
const _hoisted_4 = { class: "left" }
const _hoisted_5 = { class: "left-head" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "title" }, "标签集列表", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "新建", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "tag-list-head" }, [
  /*#__PURE__*/_createVNode("span", null, "标签集"),
  /*#__PURE__*/_createVNode("span", { class: "ops" }, "操作")
], -1)
const _hoisted_10 = { class: "tag-list-body" }
const _hoisted_11 = {
  key: 0,
  class: "system"
}
const _hoisted_12 = {
  key: 0,
  class: "ops"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "sep" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_16 = { class: "right" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")
  const _component_el_button = _resolveComponent("el-button")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Breadcrumb, null, {
      default: _withId(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: '配置标签-新建' })))
          }, {
            default: _withId(() => [
              _hoisted_7,
              _hoisted_8
            ]),
            _: 1
          })
        ]),
        _hoisted_9,
        _createVNode("ul", _hoisted_10, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tagSetList, (tagSet) => {
            return (_openBlock(), _createBlock("li", {
              onClick: ($event: any) => (_ctx.editTagSet(tagSet)),
              key: tagSet.id,
              class: {
              selected: Number(_ctx.$route.params.tagSetId) === tagSet.id
            }
            }, [
              _createVNode("div", null, [
                _createVNode("span", null, _toDisplayString(tagSet.labelSetName), 1),
                (_ctx.isSystemType(tagSet.labelSetType))
                  ? (_openBlock(), _createBlock("span", _hoisted_11, "系统内置"))
                  : _createCommentVNode("", true)
              ]),
              (tagSet.editable)
                ? (_openBlock(), _createBlock("div", _hoisted_12, [
                    _createVNode(_component_el_button, { type: "text" }, {
                      default: _withId(() => [
                        _hoisted_13
                      ]),
                      _: 1
                    }),
                    _hoisted_14,
                    _createVNode(_component_el_button, {
                      class: "button-delete",
                      type: "text",
                      onClick: _withModifiers(($event: any) => (_ctx.deleteTagSet(tagSet)), ["stop"])
                    }, {
                      default: _withId(() => [
                        _hoisted_15
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ], 10, ["onClick"]))
          }), 128))
        ])
      ]),
      _createVNode("div", _hoisted_16, [
        _createVNode(_component_router_view, { onUpdateTagSet: _ctx.loadAllLabelSet }, null, 8, ["onUpdateTagSet"])
      ])
    ])
  ]))
})